'use strict';
import get from 'lodash/get';
import isObject from 'lodash/isObject';
import 'rxjs/add/observable/combineLatest';
import 'rxjs/add/observable/merge';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/timer';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/take';
import {Observable} from 'rxjs/Observable';
import {isCordovaBuild} from '../../config/constants';
import {FIREBASE_TOKEN, PROFILE, TOKEN} from '../../config/constants/auth-keys';
import {epicErrorHandler} from '../../core-utilities/rx-utils';
import {authFirebase, firebaseAuthError, hydrateProfile, initAuth, initAuthComplete, lockSuccess} from '../actions';
import {refreshUserRequest} from '../redux/refreshUser';
import {signupUserRequest} from '../redux/signupUser';
import {getTokenStatus, loadRefreshToken, VALID} from '../utils/token';
import {logger} from './logger';


export const epics = [
  onInitAuth,
  onInitAuthComplete,
  onAuthError,
];

onInitAuth.$inject = [
  'authCacheService',
];

onInitAuthComplete.$inject = [
  'AuthService',
];

export function onInitAuth(action$, store, dependencies) {
  return action$.ofType(initAuth.TYPE)
    .mergeMap(() =>
      Observable
        .combineLatest(
          dependencies.authCacheService.getItem(PROFILE),
          dependencies.authCacheService.getItem(TOKEN),
          dependencies.authCacheService.getItem(FIREBASE_TOKEN),
          loadRefreshToken(),
        )
        .catch(err => {
          logger.warn(`Failed to retrieve existing token. Storage access failed with error="${err && err.message}".`);
          return Observable.of([null, null, null, null]);
        })
    )
    // TODO: reimplement this auto-migration path once native storage is added to migrate new storage cache to native cache.
    // .mergeMap(([profile, apiToken, firebaseToken, refreshToken]) => {
    //   if (!apiToken && !refreshToken) {
    //     try {
    //       const legacyProfile = storage.get(PROFILE);
    //       const legacyApiToken = storage.get(TOKEN);
    //       const legacyFirebaseToken = storage.get(FIREBASE_TOKEN);
    //       const legacyRefreshToken = storage.get(REFRESH_TOKEN);
    //
    //       if (legacyApiToken || legacyRefreshToken) {
    //         storage.remove(PROFILE);
    //         storage.remove(TOKEN);
    //         storage.remove(FIREBASE_TOKEN);
    //         storage.remove(REFRESH_TOKEN);
    //         return Observable
    //           .combineLatest(
    //             asyncStorage.setItem(PROFILE, legacyProfile),
    //             asyncStorage.setItem(TOKEN, legacyApiToken),
    //             asyncStorage.setItem(FIREBASE_TOKEN, legacyFirebaseToken),
    //             saveRefreshToken(legacyRefreshToken),
    //           )
    //           .catch(() => Observable.of(null))
    //           .mapTo([legacyProfile, legacyApiToken, legacyFirebaseToken, legacyRefreshToken]);
    //       }
    //     } catch (err) {
    //     }
    //   }
    //
    //   return Observable.of([profile, apiToken, firebaseToken, refreshToken]);
    // })
    .mergeMap(([profile, apiToken, firebaseToken, refreshToken]) => {
      try {
        const actions = [];
        // check for valid tokens
        const hasApiToken = getTokenStatus(apiToken) === VALID;
        const hasFirebaseToken = getTokenStatus(firebaseToken) === VALID;

        if (profile) {
          actions.push(hydrateProfile({profile}));
        }

        // if all tokens are valid
        //   return auth firebase action, use the token to auth firebase
        if (hasApiToken && hasFirebaseToken) {
          logger.debug('REDUX::onInitAuth => lockSuccess + authFirebase');
          actions.push(lockSuccess({token: apiToken, profile, refreshToken: isCordovaBuild() ? refreshToken : null}));
          actions.push(authFirebase(firebaseToken));
          return Observable.from(actions);
        }

        if (isCordovaBuild()) {
          if (refreshToken) {
            logger.debug('REDUX::onInitAuth => requestRefreshedToken');
            actions.push(refreshUserRequest.actions.sendRequest({refreshToken}));
            return Observable.from(actions);
          }
        }

        // if api token is not valid
        //   return auth initialized action, app may now start
        logger.debug('REDUX::onInitAuth => initAuthComplete');
        return Observable.of(initAuthComplete(null, null, 'onInitAuth'));

      } catch (err) {
        logger.error({err}, 'onInitAuth failed to check stored auth state.');
        return Observable.of(initAuthComplete(err, null, 'onInitAuth'));
      }
    })
    .catch(epicErrorHandler(logger, 'onInitAuth'));
}

/**
 * This will be called twice on cordova when the user is logging in on the first startup.
 * On mobile, this may not be fired at all.
 *  - Known example: if device is offline when opening without credentials, this action is not emitted.
 * @param {ActionsObservable<ReduxAction>} action$
 * @param {Store} store
 * @param dependencies
 * @return {Observable<ReduxAction>}
 */
export function onInitAuthComplete(action$, store, dependencies) {
  return action$.ofType(initAuthComplete.TYPE)
    .do((action) => {
      dependencies.AuthService.onInitAuthComplete(action.payload.err, action.payload.userId);
    })
    .filter(() => false)
    .catch(epicErrorHandler(logger, 'onInitAuthComplete'));
}

export function onAuthError(action$) {
  return action$.ofType(
    refreshUserRequest.actions.requestError.TYPE,
    signupUserRequest.actions.requestError.TYPE,
    firebaseAuthError.TYPE,
  )
    .map(action => {
      const err = isObject(action) ? get(action, 'payload.err', action) : action;
      logger.error({err}, `onAuthError failed. Warn user and allow login: ${isObject(action) ? action.type : 'null'}`);
      return initAuthComplete(err, null, 'onAuthError');
    })
    .catch(epicErrorHandler(logger, 'onAuthError'));
}



// WEBPACK FOOTER //
// ./src/js/auth/epics/initAuth.js